import React from "react";
import $ from 'jquery';

import { connect } from "react-redux";
import './SearchSender.css';
import axios from 'axios';
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import history from "../../auth/history";
import { store } from "../../redux/store";
import Avatar from 'react-avatar';
import { selectedBeneList, setSendersListDetails, setTotalSenders } from "../../redux/misc-data/misc-data.action";
import { selectedSender, setSendersListPageDetails } from './../../redux/misc-data/misc-data.action';


const httpClient = axios.create();
class SearchSenderDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
			password:'',
			otpRef:'',
			message:'',
			searchInput:'',
			showSenderVisible:false,
			errorMessage:''
		}
    }



    componentDidMount(){}
	
	componentWillUnmount(){
    }

    searchSender=(event)=>{
        console.log(event.target.value);
		this.setState({
			searchInput:event.target.value
		})

		this.searchSenderList(event.target.value);
	}
	searchSenderList(searchno){
		store.dispatch(setSendersListDetails(''));
		console.log('searchInput...'+searchno);
		var searchSenderUrl="/api/v1/dmt/customer/search/"+searchno;

		const headers = { 'Authorization': 'Bearer '+this.props.token,
		'client-id':this.props.agentInfo.id,
		'role' : this.props.clientRole}
		
		if(searchno.length>=4){
		httpClient.get(searchSenderUrl,{headers}
			).then((response) => {
				console.log('search response'+JSON.stringify(response.data));
				if(response.data.response.msg=='SUCCESS'
				  && response.data.searchStr==searchno){
					
					  this.setState({
						showSenderVisible:true
					  })

					  store.dispatch(setSendersListDetails(response.data));
					 
				
				  }else{
					this.setState({
						showSenderVisible:true
					  })
				  }
		  }).catch(error => {
			this.setState({
				showSenderVisible:true
			  })
	
			  console.log('search sender error:'+error);
			
		  }); 
  
		}else{
			this.setState({
				showSenderVisible:false
			  })
		}
	}

	senderList=()=>{

		history.push('/senders-list');
		history.go();

		
	}
	viewSendersList=(event,mobileNo)=>{

	
		event.preventDefault();
		this.setState({
			showSenderVisible:false
		  })
		store.dispatch(setSendersListDetails(''));
		
		var allsenderuRL='/api/v1/dmt/customer/details/'+mobileNo;
		const headers = { 'Authorization': 'Bearer '+this.props.token,
		'client-id':this.props.agentInfo.id,
		'role' : this.props.clientRole}

		httpClient.get(allsenderuRL,{headers}
			).then((response) => {
			  console.log('selected sender response'+JSON.stringify(response.data));
			  console.log(response.data.response.msg);
				if(response.data.response.msg=='SUCCESS'){

					  store.dispatch(selectedSender(response.data));
					  store.dispatch(selectedBeneList(response.data.customer.beneficiaries));

					
					  history.push('/sender');
					  history.go();
				  }else{
					  this.errorMessageCall(response.data.response.displayMsg);
					
				  }
		  }).catch(error => {
			
			this.errorMessageCall(error.msg);
			});
		}


		errorMessageCall=(error)=>{
			this.setState({
				errorMessage:error
			})

		}

		addSenders=()=>{
			history.push('/add-sender');
			history.go();
		}


    render(){
		


    return(

		<div class="col-12 col-md-6 col-lg-4 order-lg-2">
					<div class="topcard">
						<div class="top-box">
							<button class="lbbtn" onClick={this.senderList} type="button">View All</button>
							<i class="users"></i>
							<p>Total Senders</p>
							<h5>5,745</h5>
						
						</div>
					
						
						<div class="search-sender">
					
							<input type="text" placeholder="Search sender..." id="searchsender" 
							onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
							onKeyUp={this.searchSender}/>
							<button type="button" class="lbbtn" onClick={this.addSenders}>Add Sender</button>
							
							{this.state.showSenderVisible==true &&

							
							<div class="senderlist" id="showsender">
								Test
								{this.props.senderListDetails!=''?
								this.props.senderListDetails.response.msg=='SUCCESS' &&
							
								this.props.senderListDetails.list.map(customer=>(
									<div class="sender" onClick={e=>this.viewSendersList(e,customer.mobile)}>
									<Avatar name={customer.name} round={true} size="40" alt=""/>	
									<h4>{customer.name}</h4>
								 	<p>{customer.mobile}</p>
									</div>		
								))
								
							
							:
						
							<div class="sender">
							<button type="button" class="dbbtn" onClick={this.addSenders}>Add Sender</button>
							Sender not found
							</div>
							}
							{this.state.errorMessage!=null &&
								<div class='valid-error'>
								{this.state.errorMessage}
								</div>}
         
							</div>
							}
								
						</div>		
						</div>
				</div>
				
                	);
                } 
          }
          
          const mapStateToProps = (
              { errorMessageReduce:{errorMessage,loginErrorMessage},
               miscReduce:{phone,senderListDetails,agentInfo,token,clientRole}}
              ) => ({
                  errorMessage,loginErrorMessage,phone,senderListDetails,agentInfo,token,clientRole
          });
          
          export default connect(mapStateToProps, null)(SearchSenderDetails);
          